import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import itemBlueprintService from "../../services/item-blueprint";
import type { ItemBlueprint, ItemEntryType } from "../../../types/blueprint";
import type { SelectFieldProps } from "../../../types/components";

const useStyles = makeStyles((theme) => ({
	option: {
		fontSize: 15,
		"& > span": {
			marginRight: 10,
			fontSize: 18,
		},
	},
}));

export type SelectFieldEntryTypeProps = SelectFieldProps<
	ItemEntryType | "",
	string
> & { disabled?: boolean };

const SelectFieldEntryType = (props: SelectFieldEntryTypeProps) => {
	const classes = useStyles();
	const { t } = useTranslation();

	const {
		fullWidth,
		variant,
		margin,
		size,
		helperText,
		error,
		required,
		onChange,
		value,
		className,
		disabled,
	} = props;

	const entryTypes = itemBlueprintService.getEntryTypes(true, true);

	let defaultValue: ItemBlueprint | null | undefined = null;
	if (value) {
		defaultValue = entryTypes.find((entryType) => entryType.value === value);
	}

	return (
		<Autocomplete
			disabled={disabled}
			options={entryTypes.sort((a, b) => t(a.title).localeCompare(t(b.title)))}
			classes={{
				option: classes.option,
			}}
			autoHighlight
			getOptionLabel={(option) => {
				return option ? t(option.title) : "";
			}}
			onChange={(event, newValue) => {
				if (newValue) {
					onChange(newValue.value);
				} else {
					onChange("");
				}
			}}
			isOptionEqualToValue={(option, value) => {
				if (option) {
					return option.value === value.value;
				} else {
					return false;
				}
			}}
			value={defaultValue}
			renderInput={(params) => (
				<TextField
					className={className}
					{...params}
					label={t("TYPE")}
					required={required}
					margin={margin}
					size={size}
					variant={variant}
					helperText={helperText}
					error={error}
					fullWidth={fullWidth}
					inputProps={{
						...params.inputProps,
						autoComplete: "new-password", // disable autocomplete and autofill
					}}
				/>
			)}
		/>
	);
};

SelectFieldEntryType.defaultProps = {
	error: false,
};

SelectFieldEntryType.propTypes = {
	value: PropTypes.string,
	fullWidth: PropTypes.bool,
	error: PropTypes.bool,
	required: PropTypes.bool,
	helperText: PropTypes.string,
	variant: PropTypes.string,
	margin: PropTypes.string,
	size: PropTypes.string,
	onChange: PropTypes.func,
	className: PropTypes.string,
	disabled: PropTypes.bool,
};

export default SelectFieldEntryType;
